<!--
 * @Author: your name
 * @Date: 2021-11-25 14:55:54
 * @LastEditTime: 2025-04-08 14:33:15
-->
<template>
  <div class="pages">
    <h1 class="title">极兔速递服务条款</h1>
    <p><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">尊敬的用户：</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >欢迎使用“极兔速递+”小程序，为了使您获得愉悦和安全的服务体验，在此列明以下服务条款（以下简称“条款”），详述了您使用“极兔速递”小程序服务（以下简称“服务”）所须遵循的条款和条件，请您在使用服务之前仔细阅读。</span
      >
    </p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">一、特别申明</span></p>
    <p style="text-indent: 24rpx;color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">
      1、在您注册成为极兔速递会员的过程中，您需要通过点击同意的形式在线签署《极兔速递服务条款》、《隐私政策》，<span style="text-decoration: underline;
    font-size: 14px;
    font-weight: bold;"
      >请您务必认真阅读、充分理解条款内容后再点击同意</span
      >（尤其是以粗体加下划线标识的条款，因为这些条款会涉及对您权利的限制或您应履行的义务）。
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">如果您不同意条款、《隐私政策》或其他约定，请您停止注册。</span></p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">如果您阅读并点击同意，则表示您已充分阅读、理解并接受全部内容，并表明您已授权极兔可以依据《隐私政策》来处理您的个人信息。</span></u
      >
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">如果您对条款、《隐私政策》有任何疑问，您可以联系极兔客服。</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >2、“极兔”或“极兔速递”是指向您提供寄递等服务的各极兔主体，包括但不限于极兔速递有限公司及其直属分支机构、加盟合作伙伴等。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >3、极兔有权根据业务需要不定期修订条款，并在平台予以公布或更新。如用户不同意相关修订，请用户立即停止使用服务。经修订的条款一经在本平台公布，即产生效力。如用户继续使用服务，则将视为用户已接受经修订的条款，当用户与极兔速递发生争议时，应以最新的条款为准。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="font-family: 宋体;">本服务条款内容包括协议正文及所有极兔已经发布或将发布的各类规则。所有规则为条款不可分割的一部分与正文具有同等法律效力。</span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >4、“极兔速递+”小程序仅提供相关的下单、查询等自助服务，除此之外与服务有关的上网所需设备（包括个人电脑、手机、其它与接入互联网或移动网有关的上网装置）及所需的费用（与此服务相关的电话费、上网费、为使用移动网而支付的手机费等）均应由用户自行承担。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >5、您确认并保证您的年龄不小于14周岁（或者虽小于14周岁但已经征得您父母或法定监护人的同意），并且完全有能力理解、签署并遵守本条款和条件。</span
      >
    </p>
    <p><span style="font-family: 宋体;"> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">二、用户条款</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >1、非会员指未完成注册，但通过上网设备（包括但不限于电脑、手机、平板电脑等）访问“极兔速递+”小程序，并使用有限服务的用户。如您已注册成为会员，但在使用服务时未登录，则会被视为非会员，无法享受极兔会员的权益或优惠。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">2、“极兔速递+”小程序允许非会员使用有限的服务，具体服务包括浏览小程序页面、查看“兔兔速报”等。</span>
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">3、非会员用户可通过手机注册或微信账号快捷登录等会员注册方式成为会员。</span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">三、会员注册</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >1、用户进行注册时，必须填写准确、真实、有效的个人资料，如果提供的资料包含有不正确的信息，本平台保留终止用户使用服务资格的权利。倘若用户提供任何不真实、不准确、不完整或不能反映当前情况的资料，或极兔速递有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，极兔速递有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对服务（全部或其任何部份)以任何形式使用。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">用户的用户名中不得包含违反国家法律法规、涉嫌侵犯他人权利或干扰极兔速递正常运营秩序等的相关信息。</span>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">同一个手机号只能注册一个账号。用户注册时的手机号码是会员身份的唯一标识。</span
      ><u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">如手机号码发生变动，用户的相关信息及权益将清零。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">2、用户按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后，用户即成为会员。</span
      ><u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">除极兔存在故意或重大过失外，用户对会员账号的安全和会员账号下的所有行为结果负责。</span></u
      ><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >用户若发现任何非法盗用会员账号或存在安全漏洞的情况，请立即通告极兔。用户理解极兔对用户的请求采取行动需要合理时间，极兔对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</span
      >
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">3、用户注册成功后，可以登陆账户信息页面更改除手机号码之外的基本信息。</span></p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">四、使用规则</span></p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">1、用户在使用“极兔速递+”小程序服务过程中，必须遵循以下规定，否则“极兔速递”有权做出独立判断，立即取消该用户的会员资格并注销其用户账号：</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（1）遵守国家法律法规、当地法规及互联网相关规定。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（2）遵守所有与运单及查询服务有关的协议、规定、程序以及服务条款。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（3）不使用网络服务作非法用途。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（4）不得利用“极兔速递+”小程序的服务系统进行任何可能对互联网或移动网络正常运转造成不利影响的行为。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（5）不得利用“极兔速递+”小程序提供的下单及查询服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（6）用户在申请使用“极兔速递+”小程序下单及查询服务时，必须提供准确的个人资料，如个人资料有任何变动，必须及时更新。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（7）允许“极兔速递+”小程序通过电子邮件或其他方式向会员发送相关商业信息。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（8）不得进行有损公共利益或极兔利益的行为。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（9）不得通过盗取账号、诈骗等不正当手段获得会员信息、成长值或享受优惠。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（10）不得出借、转让会员账号给他人。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">（11）不得以会员账号当作商品进行交易（如出售、拍卖会员账号等）。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >2、“极兔速递+”小程序针对某些特定的服务的使用通过各种方式（包括但不限于网页公告、电子邮件、手机短信提醒等）做出的任何声明、通知、警示等内容视为本条款的一部分，用户如果使用该服务，视为用户同意该等声明、通知、警示的内容。</span
      >
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">3、终止服务</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >（1）通知终止：条款任何一方均可提前十五（15）日通过书面（包括但不限于电话通知、手机短信、邮件、平台消息推送等形式）通知另一方的方式终止本条款。</span
      >
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">（2）极兔速递单方终止权：</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >如用户违反本条款的任何约定、承诺、保证或平台规则，极兔速递都有权立刻终止本条款，并按照本条款约定或平台规则规定对用户进行违约处理。</span
      >
    </p>
    <p><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">（3）本条款约定的其他终止条件发生或实现，导致本条款终止。</span></p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">五、会员个人信息</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >1、在使用“极兔速递+”小程序时，您应当按照系统页面的提示准确地提供您的信息（包括但限于您的电话、寄件和收件地址、联系人姓名及电话等）。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <u><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">2、您了解并同意，您有义务保持您提供信息的真实性和准确性。如您提供的信息不实或不准确的，您应承担因此给您、他人或极兔造成的全部损失和不利后果。</span></u>
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">3、您的账户信息由您自行设置和保管，极兔在任何时候均不会主动要求您提供账号密码或验证码。</span>
    </p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">六、会员成长及权益规则</span></p>
    <p style="text-indent: 24rpx">
      <span style="font-family: 宋体;"
        >为了提高用户体验，您理解并同意，您注册成功后我们会根据您会员的成长值，划分不同的会员等级。</span
      ><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">更多会员成长值、会员等级、VIP权益等相关信息，请您登录本平台并至相关页面仔细阅读会员成长规则、兔星权益规则。</span>
    </p>
    <p><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                "> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">七、知识产权声明</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >1、“极兔速递+”小程序内所有内容，包括所有文字、图片、图形、音频、视频等都是本平台财产，均受版权、商标和其它财产所有权法律的保护。未经本网站同意，任何企业或个人均无权复制、下载、传输、再造本平台任何内容，也不得提供给第三者使用，否则应负所有法律责任。违反上述声明而给本公司造成损失的，本公司将依法追究其法律责任。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >2、“极兔速递+”小程序为提供下单及查询服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse
        engineer）、反向编译（decompile）或反汇编（disassemble）。</span
      >
    </p>
    <p style="text-indent: 24rpx"><span style="font-family: 宋体;"> </span></p>
    <p><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">八、免责声明</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >1、“极兔速递”小程序会提供其他网站的链接，这些链接的网站并非由极兔速递控制，故不对该网站的内容、其链接网站的内容及其内容的更新及转变承担任何责任，这些网站的使用及内容也不代表极兔速递的立场。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="font-family: 宋体;"
        >2、您理解并认可，除非法律有明确的规定，否则极兔不对您使用第三方支付工具遭受的任何风险或经济损失（包括但不限于不法分子利用您账户或银行卡等进行违法活动）承担责任。</span>
    </p>
    <p><span style="color: #000000; background-color: rgb(255, 255, 0); font-family: 宋体;"> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">九、通告</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >“极兔速递+”小程序会通过平台公告、电子邮件或手机短信传送等方式，把通告传送给用户，该等通告于发送之日即视为已送达收件人。</span
      >
    </p>
    <p><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                "> </span></p>
    <p style="text-indent: 24rpx"><span style="
                  font-family: 宋体;
                  font-weight: bold;
                  color: #000000;
                  font-size: 14px;margin-bottom:8px;display: block;
                ">十、法律监管</span></p>
    <p style="text-indent: 24rpx"><span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;">1、本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</span></p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >2、如发生本服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它合法条款则依旧保持对用户产生法律效力和影响。</span
      >
    </p>
    <p style="text-indent: 24rpx">
      <span style="color: #000000; font-family: 宋体;margin-bottom:8px;display: block;"
        >3、如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向上海市青浦区人民法院提起诉讼。</span
      >
    </p>
  </div>
</template>

<script>
export default {
  name: 'Argement',
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
$color999: #999999;
$color333: #333333;
.pages {
  background: #ffffff;
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;margin-bottom:8px;display: block;
  color: $color333;
}
.title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
</style>
